import React, { useContext, useEffect, useState } from "react";
import { IdentifierMappingContext } from "../IdentifierMappingContext";
import { BaseModal } from "../../common/Modal/BaseModal";
import { Close } from "@material-ui/icons";
import plantsIllustration from "../../../../assets/images/plants_illustration.png";
import { displayResponseErrors } from "../../utils/Helpers";
import { PharmacyGroupSelect } from "./PharmacyGroupSelect";
import MixpanelService from "../../utils/MixpanelService";
import { useIdentifierMappingSubmit } from "../Hooks/useIdentifierMappingSubmit";

const defaultForm = {
  group_name: null,
};

export const TransferAllIdentifiersModal = () => {
  const {
    allGroupNames,
    transferAllIdentifiersModalOpen,
    setTransferAllIdentifiersModalOpen,
    pharmacyGroupDetailsFetcher,
    activePharmacyGroup,
    coveredEntity340bId,
  } = useContext(IdentifierMappingContext);

  const pharmacy = transferAllIdentifiersModalOpen?.pharmacy;

  const [form, setForm] = useState(defaultForm);

  const { handleSubmit, submitting } = useIdentifierMappingSubmit({
    url: `/api/mapping_requests/transfer_all`,
    body: {
      id_340b: coveredEntity340bId,
      pharmacy_id: pharmacy?.id,
      pharmacy_public_id: pharmacy?.public_id,
      group_name: form.group_name,
      original_group_name: activePharmacyGroup,
    },
    successMessage: "Transfer all request submitted.",
    onSubmitSuccess: () => {
      MixpanelService.track("esp_horizon_transfer_all_identifier_submitted", {
        pharmacy_group: form.group_name,
        count_of_transfer: identifierCount,
      });

      setTransferAllIdentifiersModalOpen(false);
      setForm(defaultForm);
    },
  });

  useEffect(() => {
    setForm(defaultForm);
  }, [transferAllIdentifiersModalOpen]);

  const identifierCount =
    pharmacyGroupDetailsFetcher.data?.pharmacy_group?.pharmacies.find(
      (p) => p.public_id === pharmacy?.public_id && p.id === pharmacy?.id
    )?.identifier_associations?.length ?? 0;

  const pharmacyGroupOptions = allGroupNames.filter(
    (groupName) => groupName !== activePharmacyGroup && groupName !== "unassigned"
  );

  return (
    <BaseModal
      open={!!transferAllIdentifiersModalOpen}
      onClose={() => setTransferAllIdentifiersModalOpen(false)}
      className="modal-center"
      width={470}
    >
      <div
        className="bg--light-navy py-4 px--32 flex align-items-center border--rounded-top justify-content-end"
        style={{ height: 80 }}
      >
        <img
          className="mt--32"
          style={{ width: 145, userSelect: "none", marginRight: 70 }}
          src={plantsIllustration}
          alt="plants_illustration"
        />
        <button
          className="button button--transparent border--none w--32 h--32"
          onClick={() => {
            MixpanelService.track("esp_horizon_transfer_all_identifier_cancelled");
            setTransferAllIdentifiersModalOpen(undefined);
          }}
        >
          <Close sx={{ fontSize: 16 }} />
        </button>
      </div>
      <div className="p--32">
        <div className="flex align-items-center justify-content-between">
          <div className="t--500 t--xl">Transfer All Identifiers</div>
          <div className="t--secondary t--md">{identifierCount} selected</div>
        </div>
        <div className="mt-2 mb-4 t--md">
          Transfer this pharmacy and all {identifierCount} related identifiers out of this pharmacy
          group and into a different group. This action will impact any associated current and
          future transactions with the identifiers. Please note that any pending transfers under
          this pharmacy will be overridden.
        </div>

        <div className="mb-4">
          <div className="px--12">
            <div className="t--sm t--secondary ml-1">Pharmacy Name *</div>
            <div className="my-3">{pharmacy?.name}</div>
          </div>
          <div className="px--12">
            <div className="t--sm t--secondary ml-1">Pharmacy Address *</div>
            <div className="my-3">{pharmacy?.address}</div>
          </div>
          <div className="mt--2rem mb-4">
            <PharmacyGroupSelect
              value={form.group_name}
              onChange={(e, pharmacyGroupName) => {
                MixpanelService.track("esp_horizon_transfer_all_pgroup");
                setForm({ ...form, group_name: pharmacyGroupName || null });
              }}
              options={pharmacyGroupOptions}
            />
          </div>
        </div>

        <div className="flex align-items-center justify-content-end gap--8">
          <button
            className="button button--white"
            onClick={() => {
              MixpanelService.track("esp_horizon_transfer_all_identifier_cancelled");
              setTransferAllIdentifiersModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="button button--blue"
            onClick={() => handleSubmit()}
            disabled={!form.group_name || submitting}
          >
            Submit for Approval
          </button>
        </div>
      </div>
    </BaseModal>
  );
};
